<template>
  <CContainer fluid>
    <Loading :active.sync="isLoading"></Loading>
      <CRow class="d-flex content-center align-items-center min-vh-100">
        <CCol lg="6" xl="4">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm>
                  <h1>FIDUCIA - INDOCYBER</h1>
                  <h5>Fiduciary Management System</h5>
                  <p class="text-muted">Silahkan log in dengan akun Anda</p>
                  <CInput
                    autofocus
                    placeholder="Username"
                    v-model="username"
                    autocomplete="username email"
                    maxlength="50"
                  >
                    <template #prepend-content><CIcon name="cil-user"/></template>
                  </CInput>
                  <CInput
                    placeholder="Password"
                    type="password"
                    v-model="password"
                    autocomplete="current-password"
                    maxlength="50"
                  >
                    <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                    <!--<template #append-content>
                      <CIcon name="cil-lock-locked"/>
                    </template>-->
                  </CInput>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton @click="submit" type="submit" color="primary" class="px-4">Login</CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
  </CContainer>
</template>
<script>
export default {
  name: 'Login',
  components: {
  },
  data(){
    return {
      isLoading: false,
      username: '',
      password: ''
    }
  },
  methods: {
    submit(event){
      event.preventDefault();
      // start login process
      this.isLoading = true;
      let processUrl = "/api/user/authenticate";
      let data = new FormData();
      // data.set('username', this.username.toLowerCase());
      data.set('username', this.username);
      data.set('password', this.password);
      this.$axios.post(processUrl, data).then((response) => {
        if (response.status === 200){
          // set token clock timer directly after login
          // const now = new Date();
          // localStorage.setItem(this.$tokenClockKeyword, now.getTime());
          // localStorage.setItem(this.$tokenClockKeyword, response.data.data.exp);
          this.$store.commit('set', ['tokenClock', response.data.data.exp]);
          // set other credentials
          // localStorage.setItem(this.$tokenKeyword, response.data.data.token);
          this.$store.commit('set', ['token', response.data.data.token]);
          // localStorage.setItem(this.$userIdKeyword, response.data.data.id);
          this.$store.commit('set', ['userId', response.data.data.id]);
          // localStorage.setItem(this.$userNameKeyword, response.data.data.fullname);
          this.$store.commit('set', ['userName', response.data.data.fullname]);
          // localStorage.setItem(this.$roleIdKeyword, response.data.data.role.id);
          this.$store.commit('set', ['roleId', response.data.data.role.id]);
          // localStorage.setItem(this.$lockKeyKeyword, response.data.data.lockKey);
          this.$store.commit('set', ['lockKey', response.data.data.role.lockKey]);
          // localStorage.setItem(this.$roleNameKeyword, response.data.data.role.name);
          // localStorage.setItem(this.$sourceKeyword, response.data.data.source)
          this.$store.commit('set', ['source', response.data.data.role.source]);
          // set token for axios auth
          // this.$axios.defaults.headers.common['Authorization'] = localStorage.getItem(this.$tokenKeyword);
          this.$axios.defaults.headers.common['Authorization'] = this.$store.state.token;
          // finish login process and redirect to home (dashboard)
          this.isLoading = false;
          this.$router.push('/');
        } else {
          this.$helper.toastError(this, "Login Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Login Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
        }
        else{
          this.$helper.toastError(this, "Login Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoading = false
      });
    },
  },
  // computed: {
  //   passwordMask(){
  //     if (this.showPassword){
  //       return "text"
  //     } else {
  //       return "password"
  //     }
  //   }
  // },
  mounted(){
      this.$axios.defaults.headers.common['Authorization'] = ""
      // localStorage.removeItem(this.$tokenKeyword);
      this.$store.commit('set', ['token', ""]);
      // localStorage.removeItem(this.$tokenClockKeyword);
      this.$store.commit('set', ['tokenClock', ""]);
      // localStorage.removeItem(this.$userIdKeyword);
      this.$store.commit('set', ['userId', ""]);
      // localStorage.removeItem(this.$userNameKeyword);
      this.$store.commit('set', ['userName', ""]);
      // localStorage.removeItem(this.$roleIdKeyword);
      this.$store.commit('set', ['roleId', ""]);
      // localStorage.removeItem(this.$roleNameKeyword);
      localStorage.clear()
      sessionStorage.clear()
  }
}
</script>
